import { z } from 'zod';

const CentsSchema = z.string().regex(/^\d+$/, 'must be a non-negative integer string (cents)');
const SignedCentsSchema = z.string().regex(/^-?\d+$/, 'must be an integer string (cents)');

export const MonthlyCloseCompetenceMonthSchema = z
  .string()
  .regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'must be YYYY-MM');

export const MonthlyClosePayrollAccrualLineKindSchema = z.enum([
  'WAGES',
  'SOCIAL_CHARGES',
  'BENEFITS',
  'OVERTIME',
  'COMMISSION',
  'INSS',
  'FGTS',
  'IRRF',
  'PRO_LABORE',
  'PROFIT_DISTRIBUTION',
]);

export const MonthlyClosePayrollLineSchema = z.object({
  collaboratorUserId: z.uuid(),
  wageBaseCents: CentsSchema,
  lines: z
    .array(
      z.object({
        kind: MonthlyClosePayrollAccrualLineKindSchema,
        amountCents: CentsSchema,
      }),
    )
    .optional(),
  occurrenceId: z.uuid().optional(),
});

export const MonthlyClosePrepaidLineSchema = z.object({
  prepaidAccountKey: z.string().min(1),
  expenseAccountKey: z.string().min(1),
  amountCents: CentsSchema,
});

export const PreviewMonthlyCloseBodySchema = z.object({
  placeId: z.uuid().nullable(),
  competenceMonth: MonthlyCloseCompetenceMonthSchema,
  payrollLines: z.array(MonthlyClosePayrollLineSchema),
  prepaidLines: z.array(MonthlyClosePrepaidLineSchema),
});
export type PreviewMonthlyCloseBody = z.infer<typeof PreviewMonthlyCloseBodySchema>;

export const ConfirmMonthlyCloseBodySchema = PreviewMonthlyCloseBodySchema;
export type ConfirmMonthlyCloseBody = z.infer<typeof ConfirmMonthlyCloseBodySchema>;

export const PreviewMonthlyCloseEntrySchema = z.object({
  placeId: z.uuid().nullable(),
  accountKey: z.string(),
  competenceDate: z.iso.date(),
  amountCents: SignedCentsSchema,
  sourceType: z.enum(['PAYROLL_ACCRUAL', 'MONTHLY_CLOSE']),
});

export const PreviewMonthlyCloseResponseSchema = z.object({
  entries: z.array(PreviewMonthlyCloseEntrySchema),
  suspenseBalanceCents: SignedCentsSchema,
  blocked: z.boolean(),
});
export type PreviewMonthlyCloseResponse = z.infer<typeof PreviewMonthlyCloseResponseSchema>;

export const ConfirmMonthlyCloseResponseSchema = z.object({
  id: z.uuid(),
  entryGroupId: z.uuid(),
  status: z.enum(['CONFIRMED', 'REVERSED']),
});
export type ConfirmMonthlyCloseResponse = z.infer<typeof ConfirmMonthlyCloseResponseSchema>;

export const MonthlyCloseIdParamsSchema = z.object({
  id: z.uuid(),
});
export type MonthlyCloseIdParams = z.infer<typeof MonthlyCloseIdParamsSchema>;

export const ReverseMonthlyCloseBodySchema = z.object({
  reason: z.string(),
});
export type ReverseMonthlyCloseBody = z.infer<typeof ReverseMonthlyCloseBodySchema>;

export const ReverseMonthlyCloseResponseSchema = ConfirmMonthlyCloseResponseSchema;
export type ReverseMonthlyCloseResponse = z.infer<typeof ReverseMonthlyCloseResponseSchema>;
